import { Link } from 'react-router-dom';
import type { SupportCaseView } from '@yingbaba/types';
import { money, supportCaseStatus, supportOrderStatus } from '@yingbaba/utils';

export function SupportCaseSummary({
  value,
  orderLink,
}: {
  value: SupportCaseView;
  orderLink?: string;
}) {
  return (
    <section className="support-case-context" aria-label="客服工单进度">
      <div className="support-case-progress">
        <p className="small muted">{supportCaseStatus[value.status] || '处理中'}</p>
        {orderLink && (
          <Link className="btn btn-secondary btn-sm" to={orderLink}>
            查看关联订单
          </Link>
        )}
      </div>
      {value.order_id && (
        <details>
          <summary>
            {value.order_kind === 'digital' ? '数字资源订单' : '会员订单'} ·{' '}
            {supportOrderStatus(value.order_context)}
          </summary>
          <div className="support-case-order">
            <strong>{value.order_title}</strong>
            <p className="small muted">订单号：{value.order_id}</p>
            <p className="small muted">工单号：{value.id}</p>
            {value.order_context && (
              <p className="small">购买金额：{money(value.order_context.amount_minor)}</p>
            )}
          </div>
        </details>
      )}
      {!value.order_id && <p className="small muted">工单号：{value.id}</p>}
      {value.status === 'resolved' && (
        <p className="small muted">还有问题？在这里继续回复，客服会重新跟进。</p>
      )}
    </section>
  );
}
